import {
    changeSelectedResultNum, getSearchResults
} from 'features/searchMolecules/searchMoleculesSlice';
import {
    changeWorkingQueryMolFile, changeWorkingQueryParams
} from 'features/workingQuery/workingQuerySlice';
import { useThunkDispatch } from 'hooks';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import {
    Accordion, AccordionDetails, AccordionSummary, ClickAwayListener, Container
} from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import ResultCard from './ResultsView/ResultCard';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: { marginBottom: theme.spacing(7) },
    root: { position: 'absolute', width: '100%', zIndex: 2 },
    label: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '&>span': {
        marginRight: theme.spacing(1),
      },
    },
    resultSelectionContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      '&>div': {
        padding: theme.spacing(1),
        flex: '0 0 7rem',
      },
    },
  }),
);

const ResultSelection = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const results = useSelector(getSearchResults);
  const dispatch = useThunkDispatch();

  const [open, setOpen] = useState<boolean>(false);

  const handleToggle = () => {
    setOpen(!open);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSelection = (index: number) => {
    dispatch(changeSelectedResultNum(index));
    dispatch(
      changeWorkingQueryMolFile({ molFile: results[index].molFile, shouldJSMEUpdate: true }),
    );
    dispatch(changeWorkingQueryParams(results[index].parameters));
    handleClose();
  };

  return (
    <div className={classes.container}>
      <ClickAwayListener onClickAway={handleClose}>
        <Accordion
          expanded={open}
          onChange={handleToggle}
          square
          className={classes.root}
          style={{ margin: 0 }}
        >
          <AccordionSummary
            aria-controls="result-selection-content"
            expandIcon={<ExpandMoreIcon />}
          >
            <Container className={classes.label}>
              <Typography component="span" variant="h5">
                {t('history')}
              </Typography>
              <Typography variant="caption">({results.length})</Typography>
            </Container>
          </AccordionSummary>
          <AccordionDetails>
            <Container maxWidth="xl" className={classes.resultSelectionContainer}>
              {results.map((result, index) => (
                <ResultCard
                  result={result}
                  index={index}
                  key={`${result.refmol}-${index}`}
                  onSelection={handleSelection}
                />
              ))}
            </Container>
          </AccordionDetails>
        </Accordion>
      </ClickAwayListener>
    </div>
  );
};

export default ResultSelection;
